export default __webpack_public_path__ + "static/media/more.e16e0214.svg";